import React, { Suspense, lazy, useEffect } from "react";
import { Routes, Route } from "react-router";
import Login from "./pages/Login";
// import Dashboard from "./pages/Dashboard";
// import Screenshots from "./pages/Screenshots";
// import Timelinecharts from "./components/TimelineCharts/Timelinecharts";
// import Timelines from "./components/Dashboard/Timelines";
import ScrollToTop from "./components/ScrollToTop";
// import Roles from "./pages/roles";
// import ManagerList from "./pages/ManagerList";
// import AddRoles from "./components/Roles/AddRoles";
import AddManager from "./components/AddManager/AddManager";
import { useAppSelector } from "./app/hooks";
import ToastContainer from "./components/CustomComponents/Toaster/ToastContainer";
// import Settings from "./pages/Settings";
// import Reports from "./pages/Reports";
// import EmployeePerformance from "./pages/EmployeePerformance";
// import ExployeesLists from "./pages/ExployeesLists";
// import EmployeeOverview from "./pages/EmployeeOverview";
// import { Client } from "@stomp/stompjs";
// import SockJS from "sockjs-client";

// let stompClient: Client | null = null;

import Notification from "./pages/Notification";
import PageLayout from "./pages/PageLayout";

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Screenshots = lazy(() => import('./pages/Screenshots'));
const Roles = lazy(() => import('./pages/roles'));
const ManagerList = lazy(() => import('./pages/ManagerList'));
const Settings = lazy(() => import('./pages/Settings'));
const Reports = lazy(() => import('./pages/Reports'));
const EmployeePerformance = lazy(() => import('./pages/EmployeePerformance'));
const ExployeesLists = lazy(() => import('./pages/ExployeesLists'));
const EmployeeOverview = lazy(() => import('./pages/EmployeeOverview'));

function App() {
  const addManager = useAppSelector((state) => state.addManager);
  const syncState = useAppSelector((state) => state.settingSync);

  // useEffect(() => {
  //   stompClient = new Client({
  //     webSocketFactory: () => new SockJS("http://192.168.1.154:8080/ws?empCode=EMP001"),
  //     reconnectDelay: 5000,
  //     debug: (str) => console.log("STOMP:", str),

  //     onConnect: () => {

  //       // Subscribe to backend messages
  //       stompClient?.subscribe("/user/queue/notifications", (message) => {
  //         const data = JSON.parse(message.body);

  //         console.log("Notification:", data);

  //         // Send ACK to backend
  //         stompClient?.publish({
  //           destination: "/app/notification/ack",
  //           body: JSON.stringify({
  //             notificationId: data.id
  //           })
  //         });
  //       });
  //     }
  //   });

  //   stompClient.activate();

  //   return () => {
  //     stompClient?.deactivate();
  //   };
  // }, []);


  return (
    <>
      <ScrollToTop />
      {/* <Suspense fallback={<div className="d-flex justify-content-center align-items-center  crt-loader" style={{ width: "100vw", height: "100vh" }}>
        <img src="/images/loader/content_loader.gif" />
      </div>} > */}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<PageLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/screenshots" element={<Screenshots />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/managerList" element={<ManagerList />} />
          <Route path="/addroles" element={<Roles />} />
          <Route path="/editroles" element={<Roles />} />
          <Route path="/viewroles" element={<Roles />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/employeePerformance" element={<EmployeePerformance />} />
          <Route path="/employeelist" element={<ExployeesLists />} />
          {/* <Route path="/employeeOverview" element={<EmployeeOverview />} /> */}
          <Route path="/notification" element={<Notification />} />

          {/* <Route path="/employeeOverview/:empid" element={<EmployeeOverview />} /> */}
          <Route path="/employeeOverview" element={<EmployeeOverview />} />

        </Route>
      </Routes>
      {addManager?.modalShow && <AddManager />
      }
      {
        syncState?.isSync &&
        <div className="loader-container">
          <img src="/images/loader/content_loader.gif" className="image-loader-container" />
        </div>
      }
      <ToastContainer />
    </>
  );
}

export default App;
